import React, { Component } from "react";
import {
  Grid,
  Checkbox,
  Button,
  Typography,
  InputAdornment,
  IconButton,
  FormControl,
  Input,
  FormHelperText,
  InputLabel, Icon
} from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";
import { graphql } from "react-apollo";
import { connect } from "react-redux";
import { Link } from 'react-router-dom';

import style from "./style";
import { SIGNUP } from "../../graphql/mutations/auth";
import {setAuthToken, setBecomeChef, setUserId} from "../../redux/auth";
import { push } from "react-router-redux";
import { emailRegex, mobileRegex, passwordRegex } from "../../config/constants";
import {GoogleLogin} from "react-google-login";

class SignUpForm extends Component {
  state = {
    firstName: "",
    lastName: "",
    zipcode: "",
    mobile: "",
    becomeChefCheck: false,
    fnameErr: false,
    lnameErr: false,
    zipcodeErr: false,
    mobileErr: false,
    email: "",
    password: "",
    emailErr: false,
    passwordErr: false,
    emailErrMsg: "",
    fnameErrMsg: "",
    lnameErrMsg: "",
    zipcodeErrMsg: "",
    mobileErrMsg: "",
    passwordErrMsg: "Use at least 8 characters with letters and numbers",
    loginErr: false,
    loginErrMsg: "",
    errors: false,
    loading: false,
    showPassword: false,
    termsPrivacy: false,
    channelCode: '',
    viaChannel: false
  };

  static getDerivedStateFromProps(props, state) {
    if (props.location) {
      let updatedState = {};
      if (props.location.campaign && props.location.viaChannel) {
         updatedState = {
           ...updatedState,
          channelCode: props.location.campaign,
          becomeChefCheck: true,
          viaChannel: true,
        };
      }

      if (props.location.campaign) {
        updatedState = {
          ...updatedState,
          channelCode: props.location.campaign,
          becomeChefCheck: true,
        };
      }

      if (props.location.becomeChef) {
        updatedState = {
          ...updatedState,
          becomeChefCheck: true,
        };
      }

      return updatedState;
    }

    return null;
  }

  componentDidMount () {
    const { history: {location} } = this.props;

    if (location) {
      if (location.pathname) {
        if (location.pathname === "/sign-up-chef") {
          this.setState({ becomeChefCheck: true });
        }
      }
    }
  }


  toggleShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  handleInputChange = e => {
    const { name, value } = e.target;
    switch (name) {
      default:
        return;
      case "email":
        this.setState({ email: value });
        break;

      case "password":
        this.setState({ password: value });
        break;

      case "fname":
        this.setState({ firstName: value });
        break;

      case "lname":
        this.setState({ lastName: value });
        break;

      case "zipcode":
        this.setState({ zipcode: value });
        break;

      case "mobile":
        this.setState({ mobile: value });
        break;

      case "promoCode":
        this.setState({ channelCode: value });
        break;
    }
  };

  checkErrors = () => {
    this.setState({ loginErr: false, loginErrMsg: "" });
    let errors = false;
    const {
      email,
      password,
      firstName,
      lastName,
      zipcode,
      mobile
    } = this.state;

    if (firstName.trim().length < 2) {
      this.setState({
        errors: true,
        fnameErr: true,
        fnameErrMsg: "First Name is required (min 2 letters)"
      });
    } else {
      errors = false;
      this.setState({ errors: false, fnameErr: false, fnameErrMsg: "" });
    }

    if (lastName.trim().length <= 0) {
      this.setState({
        errors: true,
        lnameErr: true,
        lnameErrMsg: "Last Name is required"
      });
    } else {
      errors = false;
      this.setState({ errors: false, lnameErr: false, lnameErrMsg: "" });
    }

    if (password.trim().length <= 7) {
      this.setState({
        errors: true,
        passwordErr: true,
        passwordErrMsg: "Use at least 8 characters with letters and numbers"
      });
    } else if (!passwordRegex.test(password.trim())) {
      this.setState({
        errors: true,
        passwordErr: true,
        passwordErrMsg: "Use a strong password"
      });
    } else {
      errors = false;
      this.setState({ errors: false, passwordErr: false });
    }

    if (password.trim().length <= 0) {
      this.setState({
        errors: true,
        passwordErr: true,
        passwordErrMsg: "Password is required"
      });
      errors = true;
    } else {
      errors = false;
      this.setState({
        errors: false,
        passwordErr: false,
        passwordErrMsg: "Use at least 8 characters with letters and numbers"
      });
    }

    if (zipcode.trim().length !==  5) {
      errors = true;
      this.setState({
        errors: true,
        zipcodeErr: true,
        zipcodeErrMsg: "Valid ZIP Code is required"
      });
    } else if (isNaN(zipcode)) {
      errors = true;
      this.setState({
        errors: true,
        zipcodeErr: true,
        zipcodeErrMsg: "Only numbers are allowed"
      });
    } else {
      errors = false;
      this.setState({ errors: false, zipcodeErr: false, zipcodeErrMsg: "" });
    }

    if (mobile.trim().length > 0) {
      //if (mobile.trim().length ) {}
      //this.setState({ errors: true, mobileErr: true, mobileErrMsg: "Mobile Number is Required" });
      if (!/^\d+$/.test(mobile.trim())) {
        this.setState({
          errors: true,
          mobileErr: true,
          mobileErrMsg: "Only numbers"
        });
        errors = true;
      } else if (mobile.trim().length !== 10) {
          this.setState({
              errors: true,
              mobileErr: true,
              mobileErrMsg: "Must be 10 digits"
          });
      } else {
        this.setState({ errors: false, mobileErr: false, mobileErrMsg: "" });
      }
    }

    if (email.trim().length <= 0) {
      this.setState({
        errors: true,
        emailErr: true,
        emailErrMsg: "Email is required"
      });
      errors = true;
    } else if (!emailRegex.test(email.trim())) {
      this.setState({
        errors: true,
        emailErr: true,
        emailErrMsg: "Invalid Email"
      });
      errors = true;
    } else {
      errors = false;
      this.setState({ errors: false, emailErr: false, emailErrMsg: "" });
    }

    return errors;
  };

  handleBlur = e => {
    const { name, value } = e.target;
    switch (name) {
      default:
        return;
      case "email":
        if (value.trim().length <= 0) {
          this.setState({
            errors: true,
            emailErr: true,
            emailErrMsg: "Email is required"
          });
        } else if (!emailRegex.test(value.trim())) {
          this.setState({
            errors: true,
            emailErr: true,
            emailErrMsg: "Invalid Email"
          });
        }else {
          this.setState({ errors: false, emailErr: false, emailErrMsg: "" });
        }
        break;

      case "password":
        if (value.trim().length <= 7) {
          this.setState({
            errors: true,
            passwordErr: true,
            passwordErrMsg: "Use at least 8 characters with letters and numbers"
          });
        } else if (!passwordRegex.test(value.trim())) {
          this.setState({
            errors: true,
            passwordErr: true,
            passwordErrMsg: "Use a strong password"
          });
        } else {
          this.setState({ errors: false, passwordErr: false });
        }

        if (value.trim().length <= 0) {
          this.setState({
            errors: true,
            passwordErr: true,
            passwordErrMsg: "Password is required"
          });
        } else {
          this.setState({
            errors: false,
            passwordErr: false,
            passwordErrMsg: "Use at least 8 characters with letters and numbers"
          });
        }
        break;

      case "fname":
        if (value.trim().length <= 0) {
          this.setState({
            errors: true,
            fnameErr: true,
            fnameErrMsg: "First Name is required"
          });
        } else {
          this.setState({ errors: false, fnameErr: false, fnameErrMsg: "" });
        }
        break;

      case "lname":
        if (value.trim().length <= 0) {
          this.setState({
            errors: true,
            lnameErr: true,
            lnameErrMsg: "Last Name is required"
          });
        } else {
          this.setState({ errors: false, lnameErr: false, lnameErrMsg: "" });
        }
        break;

      case "zipcode":
        if (value.trim().length !== 5) {
          this.setState({
            errors: true,
            zipcodeErr: true,
            zipcodeErrMsg: "Valid ZIP Code is required"
          });
        } else if (isNaN(value)) {
          this.setState({
            errors: true,
            zipcodeErr: true,
            zipcodeErrMsg: "Only numbers are allowed"
          });
        } else {
          this.setState({
            errors: false,
            zipcodeErr: false,
            zipcodeErrMsg: ""
          });
        }
        break;

      case "mobile":
        /*if (value.trim().length <= 8 || value.trim().length >= 12) {
					this.setState({ errors: true, mobileErr: true, mobileErrMsg: "Mobile Number is Required" });
				}
				else if (!(/^\d+$/.test(value.trim()))) {
					this.setState({ errors: true, mobileErr: true, mobileErrMsg: "Only numbers" });
				}
				else {
					this.setState({ errors: false, mobileErr: false, mobileErrMsg: "" });
				}*/
        if (value.trim().length > 0) {
          //if (mobile.trim().length ) {}
          //this.setState({ errors: true, mobileErr: true, mobileErrMsg: "Mobile Number is Required" });
          if (!/^\d+$/.test(value.trim())) {
            this.setState({
              errors: true,
              mobileErr: true,
              mobileErrMsg: "Only numbers"
            });
          } else if (value.trim().length !== 10) {
              this.setState({
                  errors: true,
                  mobileErr: true,
                  mobileErrMsg: "Must be 10 digits"
              });
          } else {
            this.setState({
              errors: false,
              mobileErr: false,
              mobileErrMsg: ""
            });
          }
        }
        break;
    }
  };

  handleRegister = async e => {
    e.preventDefault();
    try {

      if (!this.state.termsPrivacy) {
        alert('You need to accept Terms of Use and Privacy Policy');
        return;
      }

      this.setState({ loading: true });

      if (this.checkErrors() || this.state.zipcode.length !== 5 || isNaN(this.state.zipcode)) {
        this.setState({ loading: false });
        return;
      }

      if (this.state.firstName.length < 2) {
        this.setState({ errors: true, fnameErr: true, fnameErrMsg: "Minimum 2 letters required", loading: false });
        return;
      } else {
        this.setState({ errors: false, fnameErr: false, fnameErrMsg: "" });
      }

      const userInput = {
        emailId: this.state.email,
        pwd: this.state.password,
        firstName: this.state.firstName,
        zipcode: this.state.zipcode,
        lastName: this.state.lastName,
        viaChannel: this.state.viaChannel
      };

      if (this.state.channelCode.trim().length > 0) {
        userInput.campaign = this.state.channelCode;
      }

      if (this.state.mobile.trim().length > 0) {
        if(this.state.mobile.trim().length > 7 && this.state.mobile.trim().length <= 10) {
          userInput.cellPhone = this.state.mobile;
        }
        else {
          this.setState({ loading: false });
          this.checkErrors();
          return;
        }
      }

      const resp = await this.props.mutate({
        variables: {
          user: userInput
        }
      });

      if (resp.data) {
        this.setState({
          loading: false,
          email: "",
          password: "",
          firstName: "",
          lastName: "",
          zipcode: "",
          viaChannel: false,
          channelCode: ''
        });
        const { dispatch, becomeChef } = this.props;

        if (this.state.becomeChefCheck) {
          dispatch(setBecomeChef(true));
        }

        dispatch(setUserId(resp.data.createUser));
        dispatch(setAuthToken(resp.authorization));
        // this.props.toggleSignUpDrawer();

        if (becomeChef || this.state.becomeChefCheck) {
          dispatch(push("/home/become-chef"));
        } else {
          dispatch(push("/home/dashboard"));
        }
      }

      if (resp.errors) {
        const errMsg = resp.errors[0].message;
        this.setState({ loginErr: true, loginErrMsg: errMsg, loading: false });
      }
    } catch (err) {
      let errorObj = JSON.parse(JSON.stringify(err));
      if (!!errorObj && errorObj.graphQLErrors) {
        const errMsg = errorObj.graphQLErrors[0].message;
        this.setState({
          loginErr: true,
          loginErrMsg: errMsg,
          loading: false,
          email: "",
          password: ""
        });
      }
    }
  };

  handleGoogleSuccess = async googleResp => {
    try {
      const resp = {...googleResp};
      const { accessToken, profileObj: { email, familyName, givenName, imageUrl } } = resp;
      const userProfile = {
        emailId: email,
        firstName: givenName,
        lastName: familyName,
        accessToken,
        pwd: accessToken
      };

      const response = await this.props.mutate({
        variables: {
          user: userProfile
        }
      });

      if (response.data && response.data.createUser) {
        const { dispatch, becomeChef } = this.props;
        dispatch(setUserId(response.data.createUser));
        dispatch(setAuthToken(response.authorization));
        // this.props.toggleSignUpDrawer();

        if (becomeChef || this.state.becomeChefCheck) {
          dispatch(push("/home/become-chef"));
        } else {
          dispatch(push("/home/dashboard"));
        }
      }
    }
    catch(error) {
      console.log('GOOGLE SIGNUP ERR: ', error);
    }
  };

  handleGoogleFailure = async googleResp => {
    try {
      console.log('GOOGLE LOGIN FAILURE RESP: ', googleResp);
    }
    catch(error) {
      console.log('GOOGLE LOGIN FAILURE ERR: ', error);
    }
  };

  handleCheckBecomeChef = (event) => {
    this.setState({ becomeChefCheck: !this.state.becomeChefCheck }, ()=> {
      const becomeChef = this.state.becomeChefCheck;
      this.props.dispatch(setBecomeChef(becomeChef));
    });
  };

  handleTermsPrivacy = (event) => {
    this.setState({ termsPrivacy: !this.state.termsPrivacy });
  };

  render() {
    return (
      <Grid container style={{ maxWidth: 420, width: '100%' }}>
        <form
          action="#!"
          method="post"
          style={{ width: "100%" }}
          name="registerForm"
          onSubmit={e => this.handleRegister(e)}
        >
          <Grid item xs={12} style={{ margin: "10px 0" }} />

          <Grid container className="sidebar-custom-container" justify='space-between'>
            <Typography variant="h5" className="side-bar-heading">
              Sign Up
            </Typography>
            {/*<Button
              size="small"
              style={{ float:'left', marginTop: -20 }}
              onClick={this.props.closeLoginDrawer}
            >
              <Icon style={{fontSize: 28}}>close</Icon>
            </Button>*/}
          </Grid>
          <Grid container>
            <div style={{ width: "100%" }}>
              <Grid item xs={12} style={style.inputCtrl}>
                <FormControl fullWidth={true}>
                  <InputLabel
                    htmlFor="FirstName"
                    style={
                      this.state.fnameErr
                        ? { ...style.setFont, ...style.error }
                        : style.setFont
                    }
                  >
                    First Name
                  </InputLabel>
                  <Input
                    error={this.state.fnameErr}
                    style={{ ...style.setFont }}
                    onChange={this.handleInputChange}
                    onBlur={this.handleBlur}
                    name="fname"
                    value={this.state.firstName}
                  />
                  <FormHelperText
                    style={
                      this.state.fnameErr
                        ? { ...style.setFont, ...style.error }
                        : { ...style.setFont, ...style.msg }
                    }
                  >
                    {this.state.fnameErrMsg}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} style={style.inputCtrl}>
                <FormControl fullWidth={true}>
                  <InputLabel
                    htmlFor="LastName"
                    style={
                      this.state.lnameErr
                        ? { ...style.setFont, ...style.error }
                        : style.setFont
                    }
                  >
                    Last Name
                  </InputLabel>
                  <Input
                    error={this.state.lnameErr}
                    style={{ ...style.setFont }}
                    onChange={this.handleInputChange}
                    onBlur={this.handleBlur}
                    name="lname"
                    value={this.state.lastName}
                  />
                  <FormHelperText
                    style={
                      this.state.lnameErr
                        ? { ...style.setFont, ...style.error }
                        : { ...style.setFont, ...style.msg }
                    }
                  >
                    {this.state.lnameErrMsg}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} style={style.inputCtrl}>
                <FormControl fullWidth={true}>
                  <InputLabel
                    htmlFor="PhoneNumber"
                    style={
                      this.state.mobileErr
                        ? { ...style.setFont, ...style.error }
                        : style.setFont
                    }
                  >
                    Cell Phone
                  </InputLabel>
                  <Input
                    error={this.state.mobileErr}
                    style={{ ...style.setFont }}
                    onChange={this.handleInputChange}
                    onBlur={this.handleBlur}
                    name="mobile"
                    value={this.state.mobile}
                  />
                  <FormHelperText
                    style={
                      this.state.mobileErr
                        ? { ...style.setFont, ...style.error }
                        : { ...style.setFont, ...style.msg }
                    }
                  >
                    {this.state.mobileErrMsg}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} style={style.inputCtrl}>
                <FormControl fullWidth={true}>
                  <InputLabel
                    htmlFor="Email Address"
                    style={
                      this.state.emailErr
                        ? { ...style.setFont, ...style.error }
                        : style.setFont
                    }
                  >
                    Email
                  </InputLabel>
                  <Input
                    error={this.state.emailErr}
                    style={{ ...style.setFont }}
                    onChange={this.handleInputChange}
                    onBlur={this.handleBlur}
                    name="email"
                    value={this.state.email}
                  />
                  <FormHelperText
                    style={
                      this.state.emailErr
                        ? { ...style.setFont, ...style.error }
                        : { ...style.setFont, ...style.msg }
                    }
                  >
                    {this.state.emailErrMsg}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} style={style.inputCtrl}>
                <FormControl fullWidth={true}>
                  <InputLabel
                    htmlFor="Password"
                    style={
                      this.state.passwordErr
                        ? { ...style.setFont, ...style.error }
                        : style.setFont
                    }
                  >
                    Password
                  </InputLabel>
                  <Input
                    error={this.state.passwordErr}
                    style={{ ...style.setFont }}
                    onChange={this.handleInputChange}
                    onBlur={this.handleBlur}
                    name="password"
                    type={this.state.showPassword ? "text" : "password"}
                    value={this.state.password}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton
                        data-test-id={"togglepwd-id"}

                          aria-label="Toggle Password Visibility"
                          onClick={this.toggleShowPassword}
                        >
                          {this.state.showPassword ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                  <FormHelperText
                    style={
                      this.state.passwordErr
                        ? { ...style.setFont, ...style.error }
                        : { ...style.setFont, ...style.msg }
                    }
                  >
                    {this.state.passwordErrMsg}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} style={style.inputCtrl}>
                <FormControl fullWidth={true}>
                  <InputLabel
                    htmlFor="zipcode"
                    style={
                      this.state.zipcodeErr
                        ? { ...style.setFont, ...style.error }
                        : style.setFont
                    }
                  >
                    ZIP Code
                  </InputLabel>
                  <Input
                    error={this.state.zipcodeErr}
                    style={{ ...style.setFont }}
                    onChange={this.handleInputChange}
                    onBlur={this.handleBlur}
                    name="zipcode"
                    value={this.state.zipcode}
                  />
                  <FormHelperText
                    style={
                      this.state.zipcodeErr
                        ? { ...style.setFont, ...style.error }
                        : { ...style.setFont, ...style.msg }
                    }
                  >
                    {this.state.zipcodeErrMsg}
                  </FormHelperText>
                </FormControl>
              </Grid>
              <Grid item xs={12} style={style.inputCtrl}>
                <FormControl fullWidth={true}>
                  <InputLabel
                    htmlFor="Campaign"
                    style={style.setFont}
                  >
                    Channel Code (Optional)
                  </InputLabel>
                  <Input
                    style={{ ...style.setFont }}
                    onChange={this.handleInputChange}
                    onBlur={this.handleBlur}
                    name="promoCode"
                    value={this.state.channelCode}
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} style={style.inputCtrl}>
                <Checkbox
                  data-test-id={"signup-check"}
                  onChange={this.handleCheckBecomeChef}
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                  value={this.state.becomeChefCheck}
                  checked={this.state.becomeChefCheck}
                /> Become a chef
              </Grid>
              <Grid item xs={12} style={style.inputCtrl}>
                <Checkbox
                  data-test-id={"signup-tnc"}
                  onChange={this.handleTermsPrivacy}
                  inputProps={{ 'aria-label': 'primary checkbox' }}
                  value={this.state.termsPrivacy}
                /> I accept <Link style={{color: '#ff8000'}} to={"/terms-of-use"}>Terms of Use</Link> and <Link style={{color: '#ff8000'}} to={"/privacy-policy"}>Privacy Policy</Link>
              </Grid>

              <Grid
                item
                xs={12}
                style={{ ...style.inputCtrl, ...style.topSpace }}
              >
                {this.state.loginErr && (
                  <Grid item xs={12} style={style.errGrid}>
                    <Typography component="p" style={style.errGridText}>
                      {this.state.loginErrMsg}
                    </Typography>
                  </Grid>
                )}
                <Button
                data-test-id={"signup-id"}

                  type="submit"
                  variant="contained"
                  disabled={this.state.loading}
                  fullWidth={true}
                  color="primary"
                  style={{ ...style.btnLogin, ...style.btnRegister }}
                >
                  Sign Up
                </Button>
              </Grid>

              <Grid
                data-test-id={"google-signup"}
                className="mbl-google"
                item
                xs={12}
                style={{ ...style.inputCtrl, ...style.topSpace, alignItems: 'center', alignContent: 'center', paddingLeft: '23%'  }}
              >
                <GoogleLogin
                  buttonText={"Sign Up with Google"}
                  onSuccess={this.handleGoogleSuccess}
                  onFailure={this.handleGoogleFailure}
                  clientId={"359174974921-najevtb0kk4jijdkt1tfdob9shdlvvtm.apps.googleusercontent.com"}
                  scope={"profile email"}
                />
              </Grid>
               <Grid container justify="center" alignItems="center">
                <Grid item xs={12} style={{ ...style.setFont, paddingLeft: 20, marginTop: 30, textAlign: 'center', marginBottom: 40 }}>
                  Already have an account? <span style={style.loginHere} onClick={() => this.props.history.push('/sign-in')}>Sign in</span>
                </Grid>
              </Grid>
            </div>
          </Grid>
        </form>
      </Grid>
    );
  }
}

const SignUpWithData = graphql(SIGNUP)(SignUpForm);

const mapStateToProps = state => {
  return {
    becomeChef: state.auth.becomeChef
  };
};

const SignUp = connect(mapStateToProps)(SignUpWithData);

export default SignUp;
